// Click-to-play/pause only for videos OUTSIDE product gallery (gallery uses click to open modal; don't let click stop video)
function isInProductGallery(video) {
  return video.closest('#SlidesCon') || video.closest('#galModal');
}

document.querySelectorAll('.product-video-not-autoplay video').forEach(function(media) {
  if (isInProductGallery(media)) return; // In gallery: click opens modal, do not toggle play/pause
  media.addEventListener('click', function() {
    var playButton = media.parentElement.querySelector('.product-video-central-play-button');
    if (media.paused || media.ended) {
      playButton.classList.add('hidden');
    } else {
      playButton.classList.remove('hidden');
    }
  });
});

document.querySelectorAll('.product-video-is-autoplay video').forEach(function(media) {
  if (isInProductGallery(media)) return; // In gallery: do not let click stop video
  media.addEventListener('click', function() {
    if (media.paused || media.ended) {
      media.play();
    } else {
      media.pause();
    }
  });
});